// Nuevo componente con tabs
import React, { useState } from 'react';
import Step3Reprocess from './steps/Step3Reprocess';
import { ReportHistoryTable } from './ReportHistoryTable';
import Step2Upload from './steps/Step2Upload';


type Props = {
  step: 'pre' | 'post';
  disableHistoryTab?: boolean;
};

const DPSAReprocessingTabs: React.FC<Props> = ({ step, disableHistoryTab = false }) => {
  const [activeTab, setActiveTab] = useState<'process' | 'history'>('process');

  const isHistoryEnabled = !disableHistoryTab;

  return (
    <div className="w-full">
      <div className="flex border-b border-gray-200 mb-4">
        <button
          onClick={() => setActiveTab('process')}
          className={`px-4 py-2 font-medium ${activeTab === 'process' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-600'}`}
        >
          {step === 'pre' ? 'Pre Processing' : 'Post Processing'}
        </button>
        <button
          onClick={() => isHistoryEnabled && setActiveTab('history')}
          disabled={!isHistoryEnabled}
          title={isHistoryEnabled ? 'View report history' : 'Coming soon'}
          className={`px-4 py-2 font-medium ${
            isHistoryEnabled ?
              (activeTab === 'history' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-600') :
              'text-gray-400 cursor-not-allowed'
          }`}
        >
          Report History
        </button>
      </div>

      {activeTab === 'process' && (
        step === 'pre' ? <Step2Upload onComplete={() => {}} /> : <Step3Reprocess onComplete={() => {}} />
      )}
      {activeTab === 'history' && isHistoryEnabled &&   <ReportHistoryTable processType={step === 'pre' ? 0 : 1} />}
    </div>
  );
};

export default DPSAReprocessingTabs;

